enum Types {
  ONLINE = 'ONLINE',
  INSTORE = 'INSTORE',
  INSTORE_ONLINE = 'INSTORE_ONLINE',
}

export default Types;
